import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as classnames from 'classnames';
function getHighlightClass(listIndex, treeIndex, swapFrom, swapLength) {
    if (listIndex === swapFrom + swapLength - 1) {
        // This block is on the bottom (target) line
        // This block points at the target block (where the row will go when released)
        return 'rst__highlightBottomLeftCorner';
    }
    if (treeIndex === swapFrom) {
        // This block is on the top (source) line
        return 'rst__highlightTopLeftCorner';
    }
    // This block is between the bottom and top
    return 'rst__highlightLineVertical';
}
function getLineClass(lowerSiblingCount, listIndex, i, scaffoldBlockCount) {
    // Если есть кто-то ниже
    if (lowerSiblingCount > 0) {
        if (listIndex === 0) {
            //Самый первый элемент в дереве, надо сделать угол вверх и вправо
            return 'rst__lineHalfHorizontalRight rst__lineHalfVerticalBottom';
        }
        //Нам сейчас не нужен, список вплотную к левой части экрана
        if (i === scaffoldBlockCount - 1) {
            //Горизонтальная линия к элементу
            return 'rst__lineHalfHorizontalRight rst__lineFullVertical';
        }
        //Вертикальная линия до следующего элемента
        return 'rst__lineFullVertical';
    }
    if (listIndex === 0) {
        //Если первый элемент в дереве
        return 'rst__lineHalfHorizontalRight';
    }
    if (i === scaffoldBlockCount - 1) {
        //Если крайний элемент в группе
        return 'rst__lineHalfVerticalTop rst__lineHalfHorizontalRight';
    }
    return '';
}
export function getScaffolds(args) {
    const { lowerSiblingCounts, listIndex, scaffoldBlockPxWidth, lineBlock, treeIndex, swapDepth, swapFrom, swapLength, rowDirection, } = args;
    const scaffolds = [];
    const scaffoldBlockCount = lowerSiblingCounts.length;
    lowerSiblingCounts.forEach((lowerSiblingCount, i) => {
        scaffolds.push(_jsx("div", { style: { width: scaffoldBlockPxWidth, height: lineBlock }, className: classnames('rst__lineBlock', getLineClass(lowerSiblingCount, listIndex, i, scaffoldBlockCount)
            //'rst__rtl'
            ) }, `pre_${1 + i}`));
        //________________Синяя стрелка, показывает куда переносить будем_______________________
        if (treeIndex !== listIndex && i === swapDepth) {
            // This row has been shifted, and is at the depth of
            // the line pointing to the new destination
            const def_style = {
                width: scaffoldBlockPxWidth,
                height: lineBlock,
            };
            scaffolds.push(_jsx("div", { style: rowDirection === 'ltr'
                    ? {
                        ...def_style,
                        right: scaffoldBlockPxWidth * i,
                    }
                    : {
                        ...def_style,
                        left: scaffoldBlockPxWidth * i,
                    }, className: classnames('rst__absoluteLineBlock', getHighlightClass(listIndex, treeIndex, swapFrom, swapLength), 'rst__rtl') }, i));
        }
    });
    return scaffolds;
}
export function getDropType(canDrop, isOver) {
    if (canDrop && !isOver) {
        return 'validDrop';
    }
    if (!canDrop && isOver) {
        return 'invalidDrop';
    }
    return '';
}
